import type { Resource } from '../../';
export const forms_error_maxLength: Resource = {"default":"The {name} field must be at most {length} characters long."};
